export enum ShareStatus {
  Idle = 'Idle',
  Success = 'Success',
  Aborted = 'Aborted',
  UnknownError = 'UnknownError',
}
